QuestionsList = require 'components/scope/outcomes/questions_list'
QuestionGroupTitle = require 'components/scope/outcomes/question_group_title'
IndividualRatingsTable = require 'components/scope/individual_ratings_table'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'

QuestionGroupForRating = createReactClass
  displayName: 'QuestionGroupForRating'
  mixins: [CustomRenderMixin]
  propTypes:
    data: PropTypes.object.isRequired

  render: ->
    name = @props.data.get 'name'
    questions = @props.data.get 'questions'
    outcomes = @props.data.get 'outcomes'

    <div className='question-group'>
      <QuestionGroupTitle text={name} />
      <QuestionsList questions={questions} groupName={name} />
      <IndividualRatingsTable
        outcomes={outcomes}
        membersMap={@props.membersMap}
      />
    </div>

module.exports = QuestionGroupForRating
